import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "max-width": "90%"
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n    " + _vm._s(_vm.$i18n_t('NiotaClassic.GWMonitoring.visualization')) + "\n  ")];
      },
      proxy: true
    }])
  }, [_c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VRow, [_c(VCol, [_c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "offset": 24,
      "title": _vm.$i18n_t('NiotaClassic.GWMonitoring.visualization'),
      "icon": "fa-info"
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('p', [_vm._v("\n                " + _vm._s(_vm.$i18n_t('NiotaClassic.GWMonitoring.visualizationInfo')) + "\n              ")])])], 1)], 1)], 1)], 1), _c(VRow, {
    staticClass: "mx-1"
  }, [_c(VCol, {
    staticClass: "mb-0 mt-2 float-right",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VSelect, {
    attrs: {
      "items": _vm.timeFrames,
      "item-text": "name",
      "return-object": "",
      "solo": ""
    },
    on: {
      "change": _vm.selectTimeFrame
    },
    model: {
      value: _vm.selectedTimeFrame,
      callback: function ($$v) {
        _vm.selectedTimeFrame = $$v;
      },
      expression: "selectedTimeFrame"
    }
  })], 1), _vm.graphData ? _c('niota-classic-gw-mgmt-charts', {
    attrs: {
      "packetsBar": _vm.packetsBar,
      "rssiGraph": _vm.rssiGraph,
      "lsnrGraph": _vm.lsnrGraph,
      "sfGraph": _vm.sfGraph,
      "loadingMetrics": _vm.loadingMetrics
    }
  }) : _vm._e(), _vm.loadingMetrics ? _c(VRow, {
    staticClass: "fill-height",
    attrs: {
      "align-content": "center",
      "justify": "center"
    }
  }, [_c(VCol, {
    staticClass: "text-subtitle-1 text-center",
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('NiotaClassic.GWMonitoring.loadingMetrics')) + "\n        ")]), _c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VProgressLinear, {
    attrs: {
      "color": _vm.color,
      "indeterminate": "",
      "rounded": "",
      "height": "6"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };